module.exports = __webpack_public_path__ + "img/9788970135830.43ffd78a.jpg";